import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { NSGridActionCellModule, NSGridModule } from '@norfolk-southern/accessns-components';

import { GuaranteesGridComponent } from '@ruby/modules/guarantees/components/guarantees-grid/guarantees-grid.component';
import { GuaranteesButtonActions } from '@ruby/modules/guarantees/containers/guarantees-button-action/guarantees-button-actions.container';
import { GuaranteesGridContainer } from '@ruby/modules/guarantees/containers/guarantees-grid/guarantees-grid.container';
import { GuaranteesRoutingModule } from '@ruby/modules/guarantees/guarantees-routing.module';
import * as fromGuarantees from '@ruby/modules/guarantees/store';
import { effects } from '@ruby/modules/guarantees/store/effects';
import { GuaranteeLiftDialogModule } from '@ruby/shared/dialogs/guarantees/guarantee-lift/guarantee-lift.dialog.module';
import {
  GuaranteeStorageDialogModule
} from '@ruby/shared/dialogs/guarantees/guarantee-storage/guarantee-storage.dialog.module';
import { GridPreferencesCustomService } from '@ruby/shared/services/grid-preferences-custom.service';

@NgModule({
  declarations: [
    GuaranteesGridContainer,
    GuaranteesGridComponent,
    GuaranteesButtonActions
  ],
  imports: [
    CommonModule,
    EffectsModule.forFeature(effects),
    GuaranteesRoutingModule,
    GuaranteeLiftDialogModule,
    GuaranteeStorageDialogModule,
    NSGridActionCellModule,
    NSGridModule.forRoot(GridPreferencesCustomService),
    MatDialogModule,
    StoreModule.forFeature(fromGuarantees.featureKey, fromGuarantees.reducer)
  ],
  providers: [],
  exports: [
    GuaranteesGridContainer
  ]
})
export class GuaranteesModule {}
